<template>
  <ul class="nav" :class="classObject">
    <slot />
  </ul>
</template>

<script>
export default {
  name: 'TabsComponent',
  props: {
    pills: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabs: [],
    };
  },
  computed: {
    classObject() {
      return [this.class, { 'nav-pills': this.pills }];
    },
  },
  methods: {
    registerTab(tab) {
      this.tabs.push(tab);
    },
    activateTab(activeTab) {
      console.log(activeTab);
      this.tabs.forEach((tab) => {
        console.log(tab);

        tab.isActive = tab === activeTab;
      });
    },
  },
  provide() {
    return {
      registerTab: this.registerTab,
      activateTab: this.activateTab,
    };
  },
};
</script>

<style lang="scss" scoped>
.nav-pills {
  ::v-deep .nav-link {
    border: 1px solid #e2e2e2;
    border-radius: 0.5rem;
    color: #212529;
    margin-right: 20px;
    .icon {
      vertical-align: middle;
      line-height: 0;
      display: inline-block;
      margin-right: 7px;
      font-size: 25px;
      margin-top: -4px;
      background-color: #f2f2f2;
      border-radius: 100%;
      padding: 22px 10px;
    }
  }
}
</style>
